import { Moment } from 'moment';
import { C_TIMELINE_MIN_DATE, C_TIMELINE_MAX_DATE } from '../constants';

export interface IScoreDeltaDates {
    virtualToday: Moment;
    dateStart: Moment;
    dateEnd: Moment;
}

export function snapToMonthEnd(date: Moment): Moment {
    const monthEnd = date
        .clone()
        .endOf('month')
        .startOf('day');
    if (monthEnd.isBefore(C_TIMELINE_MIN_DATE)) {
        return C_TIMELINE_MIN_DATE.clone();
    }
    if (monthEnd.isAfter(C_TIMELINE_MAX_DATE)) {
        return C_TIMELINE_MAX_DATE.clone();
    }
    return monthEnd;
}

export function getMonthlyScoreDeltaDates(
    dates: IScoreDeltaDates
): IScoreDeltaDates {
    const dateEnd = snapToMonthEnd(dates.dateEnd);
    let dateStart = snapToMonthEnd(dates.dateStart);
    if (dateStart.isSameOrAfter(dateEnd, 'day')) {
        dateStart = snapToMonthEnd(dateEnd.clone().subtract(1, 'month'));
    }
    return {
        virtualToday: snapToMonthEnd(dates.virtualToday),
        dateStart,
        dateEnd,
    };
}
